import { render, staticRenderFns } from "./Flashcards.vue?vue&type=template&id=65f3c322&scoped=true"
import script from "./Flashcards.vue?vue&type=script&lang=js"
export * from "./Flashcards.vue?vue&type=script&lang=js"
import style0 from "./Flashcards.vue?vue&type=style&index=0&id=65f3c322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3c322",
  null
  
)

export default component.exports